<ng-container *ngIf="purpose === 'banner'">
    <ng-container *ngIf="showBanner">
        <ng-container *ngIf="trialExpiryMessage && trialExpiryMessage !== ''">
            <app-banner [theme]="bannerConfig?.theme" 
                [title]="bannerConfig?.title"
                [description]="bannerConfig?.description"
                [buttonUrl]="bannerConfig?.buttonUrl"
                [buttonText]="bannerConfig?.buttonText"
            ></app-banner>
        </ng-container>
    </ng-container>
</ng-container>
